/**
 * Created by Ivan on 30.01.2026
 */

let ExpeditionFeastWindow;

switch (cleverapps.config.ui) {
    case "riddles":
        ExpeditionFeastWindow = RiddlesExpeditionFeastWindow;
        break;
    case "wooden":
        ExpeditionFeastWindow = WoodenExpeditionFeastWindow;
        break;
    case "tropical":
        ExpeditionFeastWindow = TropicalExpeditionFeastWindow;
        break;
    case "heroes":
        ExpeditionFeastWindow = HeroesExpeditionFeastWindow;
}